import { outreachAnalyticsSchema } from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import * as z from "zod";

export const getCampaignOutreachStats = {
  name: "getCampaignOutreachStats" as const,
  description:
    "Sends, opens, clicks and the other outreach metrics for a page of the team's campaigns, overall and per template variant. Pair it with getTeamCampaigns, which can list campaigns without these stats.",
  mutates: false,
  input: z.object({ campaignIds: z.array(z.string()).max(500) }),
  output: z.object({
    campaigns: z.array(
      z.object({
        campaignId: z.string(),
        stats: outreachAnalyticsSchema,
        variants: z.array(
          z.object({ templateId: z.string(), stats: outreachAnalyticsSchema }),
        ),
      }),
    ),
  }),
};

export type GetCampaignOutreachStatsOutput = z.infer<
  typeof getCampaignOutreachStats.output
>;
